/* eslint-disable class-methods-use-this */
class Storage {
  getItem<T extends string = string>(key: string) {
    return localStorage.getItem(key) as T | null;
  }

  setItem(key: string, value: string) {
    localStorage.setItem(key, value);
  }

  removeItem(key: string) {
    localStorage.removeItem(key);
  }

  clear() {
    localStorage.clear();
  }
}

export const storage = new Storage();
